module.exports = __webpack_public_path__ + "img/people.2cd0d3d3.jpg";